import { CommonModule, DatePipe } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, inject, ViewEncapsulation, input, output, viewChild } from '@angular/core';
import { NgbDate, NgbDatepicker, NgbDropdown, NgbModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'pp-date-picker',
  templateUrl: './date-picker.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: `
    .custom-month-grid {
      display: grid;
      grid-template-columns: auto auto;
      grid-column-gap: 1rem;
      grid-row-gap: 0.5rem;
    }
  `,
  imports: [CommonModule, NgbModule],
})
export class DatePickerComponent implements AfterViewInit {

  readonly id = input<string>();

  readonly dateSelected = output<NgbDate>();

  readonly dropdown = viewChild.required(NgbDropdown);

  // Display values
  selectedValue?: string | null;

  // Formatting pipes
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly datePipe = inject(DatePipe);

  ngAfterViewInit(): void {
    this.selectedValue = this.datePipe.transform(new Date(), 'd MMM yyyy') ?? 'Select date...';
    this.cdr.detectChanges();
  }

  /**
   * Navigates the open datepicker to the provided page number
   * @param datepicker the date picker element.
   * @param number the page number to navigate to.
   * @memberof DatePickerComponent
   */
  navigateToCalendarPage(datepicker: NgbDatepicker, number: number): void {
    const { state, calendar } = datepicker;
    datepicker.navigateTo(calendar.getNext(state.firstDate, 'm', number));
  }

  /**
   * Navigates the open date picker back to today's date.
   * @param datepicker the date picker element.
   * @memberof DatePickerComponent
   */
  navigateToToday(datepicker: NgbDatepicker): void {
    const { calendar } = datepicker;
    datepicker.navigateTo(calendar.getToday());
  }

  /**
   * Formats the selected value, closes the dropdown and emit the value.
   * @param e
   * @memberof DatePickerComponent
   */
  onDateSelected(e: NgbDate): void {
    if (!e) return;

    this.selectedValue = this.datePipe.transform(new Date(e.year, e.month - 1, e.day), 'd MMM yyyy') ?? 'Select date...';
    this.dateSelected.emit(e);
    this.dropdown().close();
  }
}
